import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { Formik } from "formik";
import { cloneDeep } from "lodash";
import React, { useEffect, useState } from "react";
import { Button, Offcanvas } from "react-bootstrap";

import {
  OIInterestFromAnyOtherForm,
  OIInterestFromBondForm,
  OIInterestFromDepositsForm,
  OIInterestFromP2PForm,
  OIInterestFromPFForm,
  OIInterestFromSavingsBankForm,
  OIInterestFromTaxRefundForm
} from "..";
import { IInterestIncomes } from "../../../../config/interfaces";
import { InterestIncomesFormInitValues } from "../../../../pages/itr-filing/efiling.config";
import { useAppSelector } from "../../../../redux/Store";
import { ITRFilingSelector } from "../../../../redux/slice/ITRFilingSlice";
import FASvgIcon from "../../../FASvgIcon";
import ScrollToFirstError from "../../../ScrollToFirstError";

type Props = {
	showCanvas: boolean;
	formValues: IInterestIncomes | null;
	handleCloseBtnPress: (salaryData: IInterestIncomes | null) => void;
};

const OIInterestIncomeDetailsForm: React.FC<Props> = (props: Props) => {
	const { showCanvas, handleCloseBtnPress, formValues } = props;

	const { isFilingReadOnly } = useAppSelector(ITRFilingSelector);

	const [initFormValues, setInitFormValues] = useState<IInterestIncomes>(
		InterestIncomesFormInitValues
	);

	useEffect(() => {
		if (showCanvas && formValues) {
			setInitFormValues(() => cloneDeep(formValues));
		} else {
			setInitFormValues(() => cloneDeep(InterestIncomesFormInitValues));
		}
	}, [showCanvas, formValues]);

	return (
		<>
			<Offcanvas show={showCanvas} placement="end" backdrop={true}>
				<Formik
					enableReinitialize={true}
					initialValues={initFormValues}
					onSubmit={(values) => handleCloseBtnPress(values)}
				>
					{({ handleSubmit, submitCount, isValid, errors }) => (
						<>
							<ScrollToFirstError submitCount={submitCount} isValid={isValid} errors={errors} />

							<Offcanvas.Header>
								<Offcanvas.Title>Interest Income details</Offcanvas.Title>
								<Button
									variant="primary"
									className="icon-only hide-offcanvas"
									onClick={() => handleCloseBtnPress(null)}
								>
									<FASvgIcon icon={faXmark} />
								</Button>
							</Offcanvas.Header>

							<Offcanvas.Body>
								<OIInterestFromSavingsBankForm />
								<OIInterestFromDepositsForm />
								<OIInterestFromPFForm />
								<OIInterestFromTaxRefundForm />
								<OIInterestFromAnyOtherForm />
								<OIInterestFromP2PForm />
								<OIInterestFromBondForm />
							</Offcanvas.Body>

							<div className="offcanvas-btns">
								{!isFilingReadOnly ? (
									<Button variant="outline-white" size="sm" onClick={() => handleSubmit()}>
										Save and Close
									</Button>
								) : (
									<Button
										variant="outline-white"
										size="sm"
										onClick={() => handleCloseBtnPress(null)}
									>
										Close
									</Button>
								)}
							</div>
						</>
					)}
				</Formik>
			</Offcanvas>
		</>
	);
};

export default OIInterestIncomeDetailsForm;
